import { render, staticRenderFns } from "./OrganizationListView.vue?vue&type=template&id=48a44bf0&"
import script from "./OrganizationListView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports